import * as PIXI from "pixi.js";
import { SpinsRemainingLandscapeProperties } from "../landscape/SpinsRemainingLandscapeProperties";
/**
 * SpinsRemainingPortraitProperties.ts
 */
export class SpinsRemainingPortraitProperties extends SpinsRemainingLandscapeProperties {
    constructor() {
        super();
        this.position = new PIXI.Point(895.5, 1673);
        this.scale.set(1.26);
    }
}
